export const LEAD_STATUS = {
  NEW: "NEW",
  QUALIFYING: "QUALIFYING",
  CONTACTED: "CONTACTED",
  DEMO_SCHEDULED: "DEMO_SCHEDULED",
  OFFER_REQUESTED: "OFFER_REQUESTED",
  WON: "WON",
  LOST: "LOST",
  NURTURE: "NURTURE",
};

export const LEAD_SOURCE = {
  WEBSITE: "WEBSITE",
  DEMO_REQUEST: "DEMO_REQUEST",
  CONTACT_FORM: "CONTACT_FORM",
  WHITEPAPER: "WHITEPAPER",
  LINKEDIN: "LINKEDIN",
  GOOGLE_ADS: "GOOGLE_ADS",
  FAIR: "FAIR",
  MANUAL: "MANUAL",
  OTHER: "OTHER",
};

export const LEAD_INTEREST = {
  OPTIMES_DEMO: "OPTIMES_DEMO",
  CONSULTING: "CONSULTING",
  OFFER: "OFFER",
  CALLBACK: "CALLBACK",
  WHITEPAPER: "WHITEPAPER",
  WEBINAR: "WEBINAR",
  OTHER: "OTHER",
};

export const PRIORITY = { LOW: "LOW", MEDIUM: "MEDIUM", HIGH: "HIGH" };

export const DEAL_STAGE = {
  NEW_LEAD: "NEW_LEAD",
  QUALIFICATION: "QUALIFICATION",
  FIRST_CONTACT: "FIRST_CONTACT",
  DEMO_PLANNED: "DEMO_PLANNED",
  NEEDS_ANALYSIS: "NEEDS_ANALYSIS",
  OFFER_SENT: "OFFER_SENT",
  FOLLOW_UP: "FOLLOW_UP",
  WON: "WON",
  LOST: "LOST",
};

export const TASK_STATUS = {
  OPEN: "OPEN",
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
  CANCELLED: "CANCELLED",
};

export const ACTIVITY_TYPE = {
  NOTE: "NOTE",
  EMAIL: "EMAIL",
  CALL: "CALL",
  MEETING: "MEETING",
  DISCUSSION: "DISCUSSION",
  OTHER: "OTHER",
  TASK_CREATED: "TASK_CREATED",
  STATUS_CHANGE: "STATUS_CHANGE",
  FORM_SUBMISSION: "FORM_SUBMISSION",
};
